import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">

      {/* Card */}
      <div className="w-[90vw] max-w-[700px] bg-[var(--bg-surface)] border border-[var(--border-subtle)] shadow-2xl rounded-xl p-6 backdrop-blur">

        <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">
          We Use Cookies 🍪
        </h2>

        <p className="text-sm text-[var(--text-secondary)] mb-4 leading-relaxed">
          We use cookies to improve your experience, analyze traffic, and
          personalize content. You can accept or reject cookies anytime.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-end">

          <button
            onClick={handleReject}
            className="px-4 py-2 text-sm rounded-lg border border-[var(--border-subtle)] text-[var(--text-secondary)] hover:bg-[var(--hover-bg)] transition"
          >
            Reject
          </button>

          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm rounded-lg bg-green-500 hover:bg-green-600 text-white font-medium shadow-md transition"
          >
            Accept
          </button>

        </div>

      </div>
    </div>
  );
}